import React, { useState } from "react";
import axios from "axios";
import { Loader2, ShieldCheck } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { useToast } from "../hooks/use-toast";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useOtpGate = (purpose) => {
  const { toast } = useToast();
  const [pending, setPending] = useState(null);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const send = (phone) => axios.post(`${API}/otp/send`, { phone, purpose }).then((r) => r.data);

  const gate = async (phone, finish) => {
    const data = await send(phone);
    if (!data.required) return finish(undefined);
    setCode("");
    setPending({ phone, finish });
  };

  const verify = async () => {
    if (code.trim().length !== 6) return;
    setBusy(true);
    try {
      await pending.finish(code.trim());
      setPending(null);
    } catch (e) {
      toast({ title: "Doğrulanamadı", description: e?.response?.data?.detail || "Kod hatalı." });
    } finally { setBusy(false); }
  };

  const resend = async () => {
    try { await send(pending.phone); toast({ title: "Kod gönderildi", description: "Yeni kod telefonunuza gönderildi." }); }
    catch (e) { toast({ title: "Gönderilemedi", description: e?.response?.data?.detail || "Tekrar deneyin." }); }
  };

  const dialog = (
    <Dialog open={!!pending} onOpenChange={(o) => !o && setPending(null)}>
      <DialogContent className="sm:max-w-sm" data-testid="otp-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display text-[#2A2224]">
            <ShieldCheck className="w-5 h-5 text-[#9E2A3B]" /> Telefon Doğrulama
          </DialogTitle>
          <DialogDescription>{pending?.phone} numarasına gönderilen 6 haneli kodu girin.</DialogDescription>
        </DialogHeader>
        <input
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
          onKeyDown={(e) => e.key === "Enter" && verify()}
          inputMode="numeric" autoComplete="one-time-code" autoFocus placeholder="••••••"
          data-testid="otp-code-input"
          className="w-full h-14 text-center text-2xl tracking-[0.5em] rounded-xl border border-[#F0DDE0] bg-[#FBF5F0] outline-none focus:border-[#C15B6B]"
        />
        <button onClick={verify} disabled={busy || code.length !== 6} data-testid="otp-verify-btn"
          className="w-full h-11 rounded-xl bg-[#9E2A3B] text-white font-medium flex items-center justify-center gap-2 hover:bg-[#861f2f] transition-colors disabled:opacity-60">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Doğrula ve Kaydı Tamamla
        </button>
        <button onClick={resend} data-testid="otp-resend-btn" className="text-sm text-[#9E2A3B] hover:underline">Kod gelmedi mi? Tekrar gönder</button>
      </DialogContent>
    </Dialog>
  );

  return { gate, dialog };
};
